import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api/api.service';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class RedashReportsService {
  constructor(
    private _apiService: ApiService,
    private http: HttpClient,
    private apiService: ApiService,
  ) {}

  downloadFile(data: any, fileName: string) {
    const blob = new Blob([data], { type: 'text/csv' });
    saveAs(blob, fileName);
  }

  getReportData(reportId: number, params: any) {
    return this._apiService.get(`shops/report/${reportId}`, {
      params,
      responseType: 'text',
    });
  }
}
